import {
  Box, Checkbox, Form, Link, ListItem,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import usePortalOption from '@hooks/usePortalOption'
import usePortalOptionValues from '@hooks/usePortalOptionValues'

import { UseCampaignPortalModalPayload } from '@modals/EditCampaignPortalModal/hooks/useCampaignPortalModal'

import type { PortalOptionModel } from '@models/types'

interface PortalOptionsProps {
  campaignPortalModalPayload: UseCampaignPortalModalPayload,
  portalOption: PortalOptionModel,
}

const PortalOption = (props: PortalOptionsProps) => {
  const { campaignPortalModalPayload, portalOption } = props

  const {
    agency,
    callbacks: {
      toggleAll,
      togglePortalOptionValueId,
    },
    campaignPortalFormPayload,
    portal,
  } = campaignPortalModalPayload

  const { options: agencyOptions } = agency || {}

  const {
    entityState: {
      enabled_portal_option_values,
    },
  } = campaignPortalFormPayload

  const optionPayload = usePortalOption(portalOption)

  const { portalOption: { title } } = optionPayload

  const portalOptionValuesPayload = usePortalOptionValues({
    filters: {
      portal_option_id: portalOption.id,
    },
  })

  const { filteredPortalOptionValues } = portalOptionValuesPayload

  // @ts-expect-error TS2339
  const hiddenOptionValues = digObject(agencyOptions, `disabled_portal_option_values.${portal.short_code}`, [])
  const availablePortalOptionValues = filteredPortalOptionValues.filter(optionValue => (
    !hiddenOptionValues.includes(optionValue.id)
  ))

  const optionValueIds = availablePortalOptionValues.map(value => value.id)

  if (!availablePortalOptionValues.length) return null

  return (
    <>
      {/*
       // @ts-expect-error TS2741 */}
      <Form.Field
        label={title}
        labelRight={(
          <Link textProps={{ fontSize: 'xsmall' }} onClick={() => toggleAll(optionValueIds)}>
            Toggle All
          </Link>
        )}
        marginTop="large"
      />

      {availablePortalOptionValues.map((optionValue) => {
        const { id, title: valueTitle } = optionValue
        const enabled = enabled_portal_option_values?.includes(id)

        return (
          // @ts-expect-error TS2339
          <ListItem.WithCheckbox
            boxProps={{ border: 'none' }}
            checkbox={(
              <Checkbox
                checked={enabled}
                onClick={() => togglePortalOptionValueId(id)}
              />
              )}
            disableHover
            key={id}
          >
            <Box color="bodyFontColor" fontSize="small">
              {valueTitle}
            </Box>
            {/*
            // @ts-expect-error TS2339 */}
          </ListItem.WithCheckbox>
        )
      })}
    </>
  )
}

export default PortalOption
